import { makeStyles } from '@material-ui/core/styles';
import { ThirdTypeCard } from 'api/generated';
import { FC } from 'react';
import { DeleteButton, SaveButton, Toolbar, ToolbarProps } from 'react-admin';

const useStyles = makeStyles({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});

export const ThirdTypeCardToolbar: FC<ToolbarProps> = (props) => {
  const thirdTypeCardRecord = props.record as ThirdTypeCard;
  const { title } = thirdTypeCardRecord;
  return (
    <Toolbar {...props} classes={useStyles()}>
      <SaveButton label="Save" disabled={props.pristine} />
      <DeleteButton
        confirmTitle="Recommendation remove"
        confirmContent={`Are you sure you want to delete item "${title}"?`}
        label="Remove"
        mutationMode="optimistic"
      />
    </Toolbar>
  );
};
